/**
 * Catalogo de campos opcionales del formulario de inventario.
 * Los campos "nombre", "tipo_id" y "cantidad" siempre son obligatorios y no aparecen aqui.
 * El usuario configura, por tipo de inventario, cuales de estos campos son relevantes.
 */
export const CAMPOS_DISPONIBLES = [
    {
        key: 'modelo',
        label: 'Modelo',
        description: 'Modelo del equipo o producto'
    },
    {
        key: 'configuracion',
        label: 'Configuracion',
        description: 'Parametros o configuracion especifica del equipo'
    },
    {
        key: 'precio_por_unidad',
        label: 'Precio por unidad',
        description: 'Precio unitario del producto o reactivo'
    },
    {
        key: 'limite_recompra',
        label: 'Limite de recompra',
        description: 'Permite capturar el minimo de unidades antes de generar alerta'
    },
    {
        key: 'idioma',
        label: 'Idioma',
        description: 'Idioma de la documentacion o interfaz del equipo'
    },
    {
        key: 'ultima_calibracion',
        label: 'Ultima calibracion',
        description: 'Fecha de la ultima calibracion del equipo'
    },
    {
        key: 'necesita_refrigeracion',
        label: 'Necesita refrigeracion',
        description: 'Indica si el producto requiere cadena de frio'
    },
    {
        key: 'tiene_fecha_caducidad',
        label: 'Tiene fecha de caducidad',
        description: 'Indica si el producto tiene fecha de caducidad'
    }
];

export const ALL_CAMPO_KEYS = CAMPOS_DISPONIBLES.map(c => c.key);
